import { VueRecaptcha } from 'vue-recaptcha';
import Dropdown from '@/components/Dropdown.vue';
import Card from '@/components/Cards/Card.vue';
import { ElementSetup } from '@/lib/element';
import UiSelect from '@/components/ui/UiSelect.vue';
import UiSelectPagination from '@/components/ui/UiSelectPagination.vue';
import UiSelectGroup from '@/components/ui/UiSelectGroup.vue';
import UiSelectTabs from '@/components/ui/UiSelectTabs.vue';
import UiIcon from '@/components/ui/UiIcon.vue';
import UiHelp from '@/components/ui/UiHelp.vue';
import UiLabel from '@/components/ui/UiLabel.vue';
import UiInputPhone from '@/components/ui/UiInputPhone.vue';
import UiInput from '@/components/ui/UiInput.vue';
import UiTextarea from '@/components/ui/UiTextarea.vue';
import UiInputSubid from '@/components/ui/UiInputSubid.vue';
import UiDatePicker from '@/components/ui/UiDatePicker.vue';
import UiCaret from '@/components/ui/UiCaret.vue';
// import ProgressBar from '@/components/ProgressBar/plugin';
// import Datepicker from 'vue-flatpickr-component';

const GlobalComponents = {
  install(Vue) {
    Vue.component('Dropdown', Dropdown);
    Vue.component('Card', Card);
    Vue.component('UiSelect', UiSelect);
    Vue.component('UiSelectPagination', UiSelectPagination);
    Vue.component('UiSelectGroup', UiSelectGroup);
    Vue.component('UiSelectTabs', UiSelectTabs);
    Vue.component('UiIcon', UiIcon);
    Vue.component('UiHelp', UiHelp);
    Vue.component('UiLabel', UiLabel);
    Vue.component('UiInputPhone', UiInputPhone);
    Vue.component('UiInput', UiInput);
    Vue.component('UiTextarea', UiTextarea);
    Vue.component('UiInputSubid', UiInputSubid);
    Vue.component('UiDatePicker', UiDatePicker);
    Vue.component('UiCaret', UiCaret);
    Vue.component('VueRecaptcha', VueRecaptcha);
    // Vue.component('Datepicker', Datepicker);
    Vue.use(ElementSetup);
    // Vue.use(ProgressBar);
  },
};

export default GlobalComponents;
